import { useMemo } from 'react';
import useIsMobile from './useIsMobile';
import useIsTablet from './useIsTablet';

const useBreakpoint = () => {
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  return useMemo(() => {
    const isDesktop = !isMobile && !isTablet;
    return {
      isMobile,
      isTablet,
      isDesktop,
      current: isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop',
    };
  }, [isMobile, isTablet]);
};

export default useBreakpoint;
